import React, { useEffect, useState } from 'react';
import { getSnippet } from '../../microservices/l10n';
import { translate } from '../../services/translate';
import UiAlert from '../ui/alert/UiAlert';
import { logger } from '../../services/logger';
import { useHeaderElementsByContent, useImmediate } from '../../services/hooks';
import { getHeaderElementsFromHtml } from '../../services/cms';
import ScriptLoader from '../script-loader/ScriptLoader';

interface Props {
    snippetKey: string;
    className?: string;
    failSilently?: boolean;
}

export default function Snippet({ className, failSilently, snippetKey }: Props) {
    const [snippetContent, setSnippetContent] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [headerElements, setHeaderElements] = useState<any[]>([]);
    const [isJqueryRequired, setIsJqueryRequired] = useState(false);
    const [isJqueryLoaded, setIsJqueryLoaded] = useState(false);

    useEffect(() => {
        loadSnippet();
    }, [snippetKey]);

    useImmediate(() => {
        if (snippetContent && isJqueryLoaded) {
            setHeaderElements(getHeaderElementsFromHtml(snippetContent));
        }
    }, [snippetContent, isJqueryLoaded]);

    useHeaderElementsByContent(headerElements);

    async function loadSnippet() {
        try {
            const snippet = await getSnippet(snippetKey);
            setIsJqueryRequired(snippet.includes('$.') || snippet.includes('$('));
            setSnippetContent(snippet);
        } catch (error) {
            logger.error('Snippet', 'loadSnippet', error);
        }

        setIsLoading(false);
    }

    if (isLoading || !snippetContent) {
        return null;
    }

    return (
        <>
            {isJqueryRequired && <ScriptLoader onLoad={() => setIsJqueryLoaded(true)} url="/lib/jquery-2.2.4.min.js" />}

            {snippetContent ? (
                <div className={className} dangerouslySetInnerHTML={{ __html: snippetContent }} />
            ) : (
                !failSilently && <UiAlert failure>{translate('Snippet loading failed!', 'ui.common')}</UiAlert>
            )}
        </>
    );
}
